module.exports = __webpack_public_path__ + "static/media/issue_11_cover.1ada456e.png";